'use client';

import { useTranslations } from "@/i18n/client";

/** Modern Manifiesto section. Two-column editorial block with horizontal separators. */
export function Manifiesto() {
  const { t, isLoading } = useTranslations();
  const m = t('manifiesto');

  if (isLoading) return null;

  return (
    <section className="border-t border-b border-[var(--color-border)] py-24 md:py-32">
      <div className="max-w-[var(--container-max)] mx-auto px-6 md:px-14">
        <h2 className="font-sans font-semibold text-[26px] sm:text-[32px] md:text-[40px] leading-[1.2] tracking-tight text-[var(--color-ink)] m-0 max-w-[900px]">
          {m.heading || 'Creemos que la '}
          <em className="not-italic font-bold text-[var(--color-accent)]">
            {m.headingAccent || 'tecnología'}
          </em>
          {' debe servir para vender más, ahorrar tiempo y hacer tu negocio más competitivo.'}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16 md:mt-20">
          <div className="font-sans text-[16px] leading-[1.7] text-[var(--color-mute)] m-0">
            {m.left || 'Nacimos en Madrid, trabajando mano a mano con carpinteros, bodas, clínicas e ingenierías.'}
          </div>
          <div className="font-sans text-[16px] leading-[1.7] text-[var(--color-mute)] m-0">
            {m.right || 'Así que invertimos el contrato: empiezas sin pagar.'}{' '}
            <span className="text-[var(--color-ink)] font-medium">
              {m.rightAccent || 'Es así de simple.'}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
